import React, { createContext, useContext, useState } from 'react';

interface User {
	fName: string;
	lName: string;
}

interface UserContextType {
	user: User;
	setUser: React.Dispatch<React.SetStateAction<User>>;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
	const [user, setUser] = useState<User>(() => {
		const stored = localStorage.getItem('HRMS-data');
		return stored ? JSON.parse(stored) : { fName: '', lName: '' };
	});

	const value = React.useMemo(() => ({ user, setUser }), [user, setUser]);
	return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
	const context = useContext(UserContext);
	if (!context) throw new Error('useUser must be used within UserProvider');
	return context;
};
